import { MutableRefObject, useEffect, useRef } from 'react';

export const useResizeObserver = (
  ref: MutableRefObject<HTMLElement | null>,
  callback: (entry: ResizeObserverEntry) => void,
) => {
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    if (!observerRef.current) {
      observerRef.current = new ResizeObserver(([entry]) => {
        callback(entry);
      });
    }

    const resizeObserver = observerRef.current;

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current]);
};
